module.exports = __webpack_public_path__ + "img/06_sub_uk.db04d2a2.svg";